import React from "react";
import { FaAlignRight } from "react-icons/fa";
import { Link } from "gatsby";
import resume from "../assets/2022.pdf";
const Navbar = ({ toggleSideBar }) => {
  return (
    <nav className="navbar">
      <div className="nav-center">
        <div className="nav-header">
          <h3>Miguel Ramirez</h3>
          <button className="toggle-btn">
            <FaAlignRight onClick={toggleSideBar}></FaAlignRight>
          </button>
        </div>
        {/* <PageLinks styleClass="nav-links"></PageLinks> */}
        <ul className="page-links nav-links">
          <li>
            <Link to="/">home</Link>
          </li>
          <li>
            <Link to="/contact">contact</Link>
          </li>
          <li>
            <a href={resume} target="_blank" rel="noreferrer">
              Resume
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
